/* src/app/shared/components/campus-supervisor-assignment-editor/campus-supervisor-assignment-editor.component.scss */
td.mat-mdc-cell:first-of-type,
td.mat-mdc-footer-cell:first-of-type,
th.mat-mdc-header-cell:first-of-type {
  padding-left: 0px;
}
.hyperlink-cell {
  color: mediumblue;
  text-decoration: underline;
  cursor: pointer;
}
.normal-cell {
  color: black;
  cursor: default;
  text-decoration: none;
}
.missingEmailAddres {
  color: #B62A39;
}
.campusSupervisorAssignment--right {
  display: flex;
  justify-content: space-between;
}
.campusSupervisorAssignment--button .campusSupervisorAssignment--button__icon {
  margin-right: 4px;
}
.campusSupervisorAssignment--button .campusSupervisorAssignment--end__button__icon {
  margin-right: 4px;
  margin-bottom: 3px;
}
.campusSupervisorAssignment--message {
  margin-right: 10px;
}
.campusSupervisorAssignmentFormContainer .campusSupervisorListContainer {
  display: block;
  margin-top: 1rem;
  min-width: 450px;
  margin-left: 50px;
}
.campusSupervisorAssignmentFormContainer .campusSupervisorListContainer .campusSupervisorListContainer--label {
  display: inline;
  font-weight: 500;
  font-size: 20px;
}
.campusSupervisorAssignmentFormContainer .campusSupervisorListContainer .campusSupervisorListContainer--selectedCampusName {
  margin-bottom: 1rem;
  border-bottom: 1px solid lightgray;
  padding-bottom: 0.2rem;
}
.campusSupervisorAssignmentFormContainer .campusSupervisorListContainer .campusSupervisorList {
  height: 22em;
  overflow-y: scroll;
}
.campusSupervisorAssignmentFormContainer .campusSupervisorListContainer .campusSupervisorList .campusSupervisorListItem .listRow {
  display: flex;
}
.campusSupervisorAssignmentFormContainer .campusSupervisorListContainer .campusSupervisorList .campusSupervisorListItem .listRow .listDetailLeft {
  width: 25rem;
}
.campusSupervisorAssignmentFormContainer .campusSupervisorListContainer .campusSupervisorList .campusSupervisorListItem .listRow .listDetailRight .editCampusSupervisorContainer--button {
  justify-content: right;
  top: 1.2rem;
}
.campusSupervisorAssignmentFormContainer .campusSupervisorListContainer .campusSupervisorList .campusSupervisorListItem .listRow .listDetailRight .editCampusSupervisorContainer--button .editCampusSupervisorContainer--button__icon {
  color: #A3A3A3;
}
.campusSupervisorAssignmentFormContainer .campusSupervisorListContainer .campusSupervisorList .campusSupervisorListItem .listRow .listDetailRight .editCampusSupervisorContainer--button .editCampusSupervisorContainer--button__icon:hover {
  color: #A3A3A3;
  background-color: white;
  border-radius: 50%;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  height: 30px;
  width: 30px;
  padding-top: 0.4rem;
}
.campusSupervisorAssignmentFormContainer .campusSupervisorListContainer .campusSupervisorList .campusSupervisorListItem matListItemLine {
  white-space: nowrap;
}
.campusSupervisorAssignmentFormContainer .campusSupervisorListContainer .campusSupervisorList .campusSupervisorListItem .campusSupervisorListItem--campusSupervisorName {
  font-weight: 600;
  display: inline-block;
  min-width: 14em;
}
.campusSupervisorAssignmentFormContainer .campusSupervisorListContainer .campusSupervisorList .campusSupervisorListItem .campusSupervisorListItem--teaId {
  padding-left: 1.5rem;
  display: inline-block;
  min-width: 14em;
}
.campusSupervisorAssignmentFormContainer .campusSupervisorListContainer .campusSupervisorList .campusSupervisorListItem .campusSupervisorListItem--campusSupervisorEmail mat-icon {
  vertical-align: middle;
  color: #A3A3A3;
}
.campusSupervisorAssignmentFormContainer .campusSupervisorListContainer .campusSupervisorList .campusSupervisorListItem .campusSupervisorListItem--campusSupervisorEmail .campusSupervisorListItem--campusSupervisorEmail__icon {
  font-weight: 100;
  font-size: 1.2rem;
}
.campusSupervisorAssignmentFormContainer .campusSupervisorListContainer .campusSupervisorList .campusSupervisorListItem .campusSupervisorListItem--certArea {
  padding-left: 1.5rem;
  display: inline-block;
  width: 35em;
  font-size: 0.9em;
}
.campusSupervisorAssignmentFormContainer .campusSupervisorListContainer .newCampusSupervisorSection {
  text-align: center;
  padding: 0.5rem 0;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-right: 2rem;
}
.campusSupervisorAssignmentFormContainer .campusSupervisorListContainer .newCampusSupervisorSection .newCampusSupervisorSection--button {
  margin: 0;
  width: 15rem;
}
.campusSupervisorAssignmentFormContainer .campusSupervisorListContainer .noCampusSupervisors {
  width: 37rem;
  height: 22em;
}
.campusSupervisorAssignmentFormContainer .campusSupervisorListContainer .noCampusSupervisors .noCampusSupervisors--label {
  display: block;
  margin: 1rem 0 0 0;
  font-weight: 500;
  font-size: 20px;
}
.campusSupervisorAssignmentFormContainer .campusSupervisorListContainer .noCampusSupervisors .noCampusSupervisors--selectedCampusName {
  margin-bottom: 1rem;
  border-bottom: 1px solid lightgray;
  padding-bottom: 0.2rem;
}
.campusSupervisorAssignmentFormContainer .campusSupervisorListContainer .noCampusSupervisors .noCampusSupervisors--message {
  font-weight: 600;
}
.campusSupervisorAssignmentFormContainer .selectedCampusSupervisorFields {
  padding: 1rem 0 1em 2em;
}
.campusSupervisorAssignmentFormContainer .startDateField {
  padding: 1rem 0 1em 2em;
}
.list-row {
  display: flex;
  flex-direction: row;
}
.edit-icon {
  margin-left: auto;
  margin-right: 1em;
}
.formFields {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  z-index: 1;
}
.formFields--rightSide {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: flex-start;
  margin-left: 50px;
  justify-content: space-between;
}
.formFields--rightSide .formFields--contact-name {
  display: block;
  height: 20px;
}
.formFields--rightSide .formFields--rightSide--field {
  padding-bottom: 0.5rem;
}
.formFields--rightSide .saveAndCancelButtons {
  display: flex;
  white-space: nowrap;
  vertical-align: bottom;
  padding: 1rem 0 1em 2em;
  bottom: 0;
  right: 0;
  margin-bottom: 10px;
}
.formFields--rightSide .saveAndCancelButtons button {
  width: 100px;
}
.formFields--rightSide .saveAndCancelButtons button:not(:first-child) {
  margin-left: 2em;
}
.formFields--contactEditorContainer {
  display: flex;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 50px;
}
fieldset {
  margin-top: 0.75rem;
}
fieldset mat-form-field {
  width: 100%;
}
.campusSupervisor-assignment-editor-container {
  display: flex;
  overflow: hidden;
  flex-direction: column;
}
.campusSupervisorAssignmentEditorFormFields {
  display: flex;
}
tr.campus-supervisor-assignment-row {
  height: 0;
}
.no-assigned-campusSupervisors-message {
  margin-top: 15px;
}
.campusSupervisor-email-cell {
  width: 300px;
}
/*# sourceMappingURL=campus-supervisor-assignment-editor.component.css.map */
